

const apiConfig = {
  // Set the base URL for your API
  apiUrl: '/api/researcher/v1/',
};

export { apiConfig };
